import { createRouter, createWebHistory } from 'vue-router';
import Home from '@views/home.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory('/ro_gongchuangye'),
  routes
});

export default router;
